import React from 'react';
import ReactPaginate from 'react-paginate';
import { SetStateAction } from 'react';

import type { ITableSettingsLegacy } from 'constants/Table/interfaces';

interface IPaginatorProps {
  pageSize: number;
  totalProducts: number;
  setTableSettings: (data: SetStateAction<ITableSettingsLegacy>) => void;
  tableSettings: ITableSettingsLegacy;
}

interface ISelectedPaginate {
  selected: number;
}

const Paginator: React.FC<IPaginatorProps> = ({
  pageSize,
  totalProducts,
  setTableSettings,
  tableSettings,
}) => {
  const [pageCount, setPageCount] = React.useState(0);
  const [currentPage, setCurrentPage] = React.useState<number>(
    tableSettings.page - 1
  );

  React.useEffect(() => {
    setPageCount(Math.ceil(totalProducts / pageSize));
  }, [pageSize, totalProducts]);

  React.useEffect(() => {
    if (pageCount !== 0 && pageCount <= currentPage) {
      handlePageClick({ selected: pageCount - 1 });
    }
  }, [currentPage, pageCount]);

  const handlePageClick = (data: ISelectedPaginate) => {
    setCurrentPage(data.selected);
    setTableSettings((prev) => {
      return {
        ...prev,
        page: data.selected + 1,
      };
    });
  };

  return (
    totalProducts <= pageSize ? <div></div> :
    <div>
      <ReactPaginate
        breakLabel="..."
        nextLabel={
          <>
            <span className="sr-only">Next</span>
            <wbr />
            <svg className="h-4 w-4 fill-current" viewBox="0 0 16 16">
              <path d="M6.6 13.4L5.2 12l4-4-4-4 1.4-1.4L12 8z" />
            </svg>
          </>
        }
        forcePage={currentPage}
        onPageChange={handlePageClick}
        containerClassName={'flex paginator'}
        pageClassName={
          'bg-c-light-gray dark:bg-c-light-black hover:bg-c-blue dark:hover:bg-c-blue border border-c-gray outline-none w-[38px] h-[38px] rounded-[4px]'
        }
        pageLinkClassName={
          'inline-flex items-center justify-center rounded-[4px] leading-5 px-3 py-2 outline-none w-[38px] h-[38px] text-c-blue dark:text-c-gray hover:text-white bg-transparent hover:bg-transparent'
        }
        breakLinkClassName={
          'inline-flex items-center justify-center leading-5 px-3 py-2 bg-c-light-gray dark:bg-c-light-black border border-c-gray text-c-blue dark:text-c-gray outline-none'
        }
        nextLinkClassName={
          'inline-flex items-center justify-center rounded-[4px] leading-5 ml-3 bg-c-light-gray dark:bg-c-light-black hover:bg-c-blue border border-c-gray text-c-blue dark:text-c-gray hover:text-white shadow-sm outline-none w-[38px] h-[38px]'
        }
        previousLinkClassName={
          'inline-flex items-center justify-center rounded-[4px] leading-5 mr-3 bg-c-light-gray dark:bg-c-light-black hover:bg-c-blue border border-c-gray text-c-blue dark:text-c-gray hover:text-white shadow-sm outline-none w-[38px] h-[38px]'
        }
        activeClassName={
          'inline-flex items-center justify-center rounded-[4px] leading-5 px-3 bg-c-blue py-2 hover:bg-c-dark-blue border border-c-blue text-white outline-none w-[38px] h-[38px]'
        }
        pageRangeDisplayed={2}
        marginPagesDisplayed={1}
        pageCount={pageCount}
        previousLabel={
          <>
            <span className="sr-only">Previous</span>
            <wbr />
            <svg className="h-4 w-4 fill-current" viewBox="0 0 16 16">
              <path d="M9.4 13.4l1.4-1.4-4-4 4-4-1.4-1.4L4 8z" />
            </svg>
          </>
        }
      />
    </div>
  );
};

export default Paginator;
